import { createFileRoute, Link, useRouter } from '@tanstack/react-router'


import styles from './styles.module.scss'
import { useAtom } from 'jotai'
import { userAtom } from '@/store/atoms/user.atom'
import { currencyFormat } from '@/utils/currency-format'
import { cardsServiceInstance } from '@/services/cards.service'
import { CACHE_KEYS } from '@/common/constants'

export const Route = createFileRoute('/mobile/profile/')({
  component: RouteComponent,
  loader: async () => {
    const [mePendingCards] = await Promise.all([
      cardsServiceInstance.mePending(),
    ])
    return {
      mePendingCards
    }
  },
  shouldReload: true,
})

function RouteComponent() {
  const router = useRouter()
  const { mePendingCards } = Route.useLoaderData()
  const [user, setUser] = useAtom(userAtom)

  const onQuit = () => {
    localStorage.removeItem(CACHE_KEYS.TOKEN)
    router.navigate({ to: '/' })
    setUser(undefined)
  }

  return (
    <div className={styles.container}>
      <header>
        <div>
          <button
            onClick={() => router.navigate({ to: '/mobile/home' })}
          >
            <img
              src="/assets/btn_close.png"
            />
          </button>
        </div>
        <img
          src="/assets/profile.png"
        />
        <div className={styles.container_details}>
          <div>
            <img className={styles.coin} src="/assets/coin.svg" />
            <span>{currencyFormat(user?.wallet.amount ?? 0)}</span>
          </div>
          <div>
            <img src="/assets/signboard.svg" />
            <span>{mePendingCards}</span>
          </div>
        </div>
        {
          user && user?.wallet?.amount > 0 && (
            <button onClick={() => router.navigate({ to: '/mobile/withdraw' })}>
              <img
                src="/assets/withdrawal.png"
              />
            </button>
          )
        }
      </header>

      <ul>
        <li>
          <Link to="/mobile/cards">
            <img
              src="/assets/my_cards.png"
            />
          </Link>
        </li>
        <li>
          <Link to="/mobile/policies">
            <img
              src="/assets/usage_policies.png"
            />
          </Link>
        </li>
        <li>
          <Link to="/mobile/extractions">
            <img
              src="/assets/extraction.png"
            />
          </Link>
        </li>
        <li>
          <a href={import.meta.env.VITE_LINK_URL} target="_blank" rel="noreferrer">
            <img
              src="/assets/contact_us.png"
            />
          </a>
        </li>
      </ul>
      <footer>
        <button onClick={onQuit}>
          <img src="/assets/sair.png" />
        </button>
      </footer>
    </div>
  )
}
